module.exports = __webpack_public_path__ + "static/img/部件组成1-毫米波雷达.6c0bcb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-3/部件组成1-毫米波雷达.png
// module id = ke5N
// module chunks = 0